import React from 'react';
import { createRoot } from 'react-dom/client';
import store from './store';
import AppRoutes from './routes';
import { Provider } from "react-redux";
import './index.css';
import './styles/global.css';
import './styles/icon-fonts.css';
import './styles/fonts.css';
// import App from './App';
import * as serviceWorker from './serviceWorker';
import { initialize as initializeGoogleAnalytics } from './globs/utils/google-analytics';
import environmentVariables from './globs/utils/get-environment-variables';

initializeGoogleAnalytics(environmentVariables.REACT_APP_RUNTIME_GA_PROPERTY_ID);

// Firebase will be initialized only after user logs in and grants permission
// This prevents the browser from prompting for notifications on page load
// import registerServiceWorker from './registerServiceWorker';

// const history = syncHistoryWithStore(BrowserRouter, store);

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
    <Provider store={store}>
        <AppRoutes />
    </Provider>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register();
// registerServiceWorker();